//BACKUP FOR LIVE SITE Jan 23 2025
import React, { Component } from 'react'
import axios from 'axios'
import { connect } from 'react-redux'
import {
  SHOW_CALF, SIMPLE_VAL2, CHECK_TOKEN, SHOW_TOAST, FB_URL
} from '../store/actions/types'
import { showCalf } from '../store/actions/calfActions'
import { convertToken, getMyToken, createToken, getAdmin, checkToken } from '../store/actions/companyAdminActions'
import AddMyTokensDialog from '../components/Dialogs/AddMyTokensDialog'
//components/Dialogs/AddMyTokensDialog.js
import ReactPlayer from 'react-player'
import img1 from './eximg/img1a.jpg'
import img2 from './eximg/img2.jpg'
import img3 from './eximg/img3.jpg'
import * as qs from 'qs'
import GenTutorial from './PointsSurveys/GenTutorial'
import {
  isMobile,
  isBrowser
} from 'react-device-detect'
import { simpleValAction2 } from '../store/actions/simpleValAction2'
import { showToast } from '../store/actions/toastAction'
//import GetUserField from './GetPatron'
import firebase from '../store/firebase'
import { query, orderByChild, equalTo, get, ref } from "firebase/database";

import { initializeApp } from 'firebase/app';
import { getAuth, updateUser } from "firebase/auth";
import { signOut } from '../store/actions/authActions'
import PrevPage from './PrevPage'
import     './Sendmecoins.js';
import CryptoJS from 'crypto-js';
import moment from 'moment-timezone';
import { useLocation } from 'react-router-dom';
//import { getFunctions, httpsCallable } from "firebase/functions";
// import { getFunctions, httpsCallable } from "firebase/functions";
// import { getApp } from "firebase/app"; // usually not needed if already initialized

class GotoPersonPledge extends React.Component {
  state = {
    code: null,
    calfmember: false,
    tokenData: null,
    success: true,
    openDialog: false,
    tokenRex: false,
    oauthGrantCode: false,
    NewWalletAddress: '',
    PrivateKey: '',
    coinsBought: 0,
    mevInWallet: '',
    walletAddress: '',
    mevCoinPriceInUSD: '',
    pledgeStart: null,
    patronEmail: this.props.patronemail
  };

  constructor(props) {
    super(props)
   // this.confirmPledge = this.confirmPledge.bind(this);
   console.log('gotopatreonxx 1 : ', this.props.patronEmail)

   if ( this.props.rep===true ) {this.props.history.push('/gotopersonpledge')} //correct url to use oauthGrantCodex

  //  var url1 = window.location.href;
  //  var urly = url1.substring(
  //    url1.indexOf("=") + 1, 
  //    url1.lastIndexOf("&")
  //  );
  //  console.log('gotopatreonxx 4 : ', urly);
  //   if (urly===false) {
     
  //   } else {
  //    if ( this.props.rep===true ) {this.props.history.push('/gotopatreon')} 
  //   }

    // this.sendGetRequest(this.props.calfemail, this.props, '2') //set onething = true if on calf databse
  }

  askPermission = () => {
    const { tokenRequested} = this.props
    // this.props.loadingAction({
    //   leaderboard_loading: 1,
    //   type: LEADERBOARD_LOADING
    // })
    console.log('inside askpermission 1 ', tokenRequested)
    const promise = this.getPermission()
    promise.then(this.onFulfilled, this.onRejected)
  }

  handleCloseDialog = () => {
    console.log('green createToken usersData 2 : ', this.state.openDialog);
    this.setState({ openDialog: !this.state.openDialog })
  };

///////////////////////////////////////////
getOwnerProps(props, typ) {
  console.log('green createToken params 0 : ', props); 
  for (let x in props) {
    switch(typ) {
      case 'email':
        return props[x].email
        break;
      case 'firstName':
        return props[x].firstName
        break;
      case 'lastName':
        return props[x].lastName
        break;
      case 'companyID':
        return props[x].companyID
        break;
      case 'userID':
        return props[x].userID
        break;
      default:
        // code block
    }
  }
}

loadTokenA = (params, data) => {
  console.log('loadtokenA 1 : ', this.props)
 // if (this.props.adminAcc) {
   const promise = this.loadTokenB(params, data)
   promise.then(this.onFulfilled, this.onRejected)
 // } 
}

loadTokenB = (params, data) => {
  const { createToken } = this.props
  return new Promise((resolve, reject) => {
    setTimeout(() => {
      console.log('this.props.adminAcc 4 : ', this.props.adminAcc)    
      if (this.state.success) {
        let data = {
          email: this.getOwnerProps(this.props.adminAcc, 'email'),
          firstName: this.getOwnerProps(this.props.adminAcc, 'firstName'),
          lastName: this.getOwnerProps(this.props.adminAcc, 'lastName'),
          companyID: this.getOwnerProps(this.props.adminAcc, 'companyID'),
          userID: this.getOwnerProps(this.props.adminAcc, 'userID'),
    
          personID: this.props.userdata.userID, //token sent to
          personName: this.props.userdata.firstName,
          personLastName: this.props.userdata.lastName,
          personEmail: this.props.userdata.email,
          tokenType: params.tokenType,
         // amount: this.props.amount
        } 
        //console.log('green createToken params 1 : ', this.props);  
        console.log('green createToken params 2 : ', data);  
         if (data.email) {
          createToken(data);
          console.log('in createToken 1')
        } 
         else
         {
          console.log('in createToken 2 - no data')
         }
      } else {
        reject('Failed to the user list')
      }
    }, 10000)
  })
}

  handleSubmitUser = async usersData => {
    const { getAdmin, userdata } = this.props
     let data = {companyID: userdata.companyID}
     this.setState({tokenRex: true})

     let paramsX = {
      type: SHOW_TOAST,
      open: true,
      variant: 'success',
      message: 'Your Token has been Requested. Please wait a moment.'
    }

    this.props.showToast(paramsX)

     await getAdmin(data);

    let params={
      tokenType: usersData.tokenType
    }
    console.log('loadTokenA 0 ', this.props)
    this.loadTokenA(params, data)

       // this.handleCloseDialog()
  };

  getPermission = () => {
    const { convertToken, onething, simpleValAction2, getMyToken, mytoken, tokenRequested } = this.props
    var tokentext
    var tok;

    console.log('inside askpermission 2 ', tokenRequested)
    return new Promise((resolve, reject) => {
      setTimeout(() => {
        console.log('inside askpermission 3', tokenRequested)
        console.log('green token reducer 0 ', this.props.mytoken)
        if (this.state.success) {
          console.log('inside askpermission 4', this.props.onething)
         // if (this.state.calfmember === true && this.props.userdata.from !== 'StrategyX') { // FIRST TIME GOING THROUGH
         // && this.props.userdata.from !=='StrategyX'
             if (this.props.mytoken && tokenRequested === 'yes' && this.props.onething === true ) { // FIRST TIME GOING THROUGH means user is on calf database
            //token requested and payment already made
            //CALF PRODUCTS MODIFY HERE
            console.log('inside askpermission 5')
            if (this.props.mytoken.tokenType === 'app') { tokentext = 'ThinkLead app' }
            if (this.props.mytoken.tokenType === 'ex1') { tokentext = 'Executive Club 1' }
            if (this.props.mytoken.tokenType === 'ex2') { tokentext = 'Executive Club 2' }

            tok = this.props.mytoken.token

            // const answerToken = prompt(
            //   'Please provide a Token to join the Executive Club.'
            //   + ' You have purchased the ' + tokentext + '. ' + 
            //   'Here is your token: ' + tok + '', tok
            // )
            answerToken = 'yes'
           // if (answerToken === '' || answerToken === null || answerToken === 'no') {
           //   console.log('green token reducer 6')
           // } else {
              console.log('tokenRequested 3 : ', this.props.tokenRequested );
              this.sendGetRequest(this.props.calfemail, this.props, '3') //set execmember=true & open EC
              let val = {
                token: answerToken,
                userID: this.props.userdata.userID
              }
              convertToken(val)  // CONVERT TOKEN TO CREDIT
           // }
          }
          else {

            
          }
        } 
        else {
          reject('Failed to the user list')
        }
      }, 6000)
    })
  }

  findTokenA = () => {
    console.log('greentokenusers 6 : ', this.props.tokenRequested);
    const promise = this.findTokenB()
    promise.then(this.onFulfilled, this.onRejected)
  }
  
  findTokenB = () => {
    const { tokenRequested } = this.props
   
    return new Promise((resolve, reject) => {
      setTimeout(() => {
        if (this.state.success) {
          console.log('greentokenusers 7 : ', this.props.tokenRequested);
        
          if (tokenRequested==='no' || tokenRequested===undefined) {
            this.setState({openDialog: true})
           }
        } else {
          reject('Failed to the user list')
        }
      }, 6000)
    })
  }
//////////////////////////////////////////////////////////////////////////////////////////
// handleOAuthRedirectRequest(request, response) {
//   // const CLIENT_ID = null     // Replace with your data
//   // const CLIENT_SECRET = null // Replace with your data
//   // const redirectURL = null   // Replace with your data

//   const redirectURL = 'https://thinklead.app'; //'http://localhost:3000/callback'; // This should match your redirect URI in the Patreon Developer Dashboard
//   const CLIENT_ID = '4uk2TdW-YL2r-YB-sVcqw9jzGQhzZX-YFJs6b10hR372n5qjoQG0PsLLfIvga-Ti'     // Replace with your data
//   const CLIENT_SECRET = 'aQdMxoIIhT_NWoiKgxmD_KBcmzshHDkKvYD_7W5-UZS62DGTwlFDM79exw2NmbIn' 

//   const patreonOAuthClient = patreonOAuth(CLIENT_ID, CLIENT_SECRET)
//   const oauthGrantCode = url.parse(request.url, true).query.code

//     patreonOAuthClient
//         .getTokens(oauthGrantCode, redirectURL)
//         .then(tokensResponse => {
//             const patreonAPIClient = patreonAPI(tokensResponse.access_token)
//             return patreonAPIClient('/current_user')
//         })
//         .then(({ store }) => {
//             response.end(store.findAll('user').map(user => user.serialize()))
//         })
//         .catch(err => {
//             console.error('error!', err)
//             response.end(err)
//         })
// }

//     //Get the raw json from the response. See for the expected format of the data
//     patreon_response = patreon_client('/current_user').then(function(result) {
//       user_store = result.store
//       const data = result.rawJson
//       /*  data.data will contain the current_user, but there might be more users returned and loaded into the store.
//       *  Get the id of the requested user, and find it in the store
//       */
//       const myUserId = data.data.id
//       creator = user_store.find('user', myUserId)
//     })

  getSubstring(string, char1, char2) {
    return string.slice(
      string.indexOf(char1) + 1,
      string.lastIndexOf(char2),
    );
  }
  
  makeid(length) {
    var result           = '';
    var characters       = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    var charactersLength = characters.length;
      for ( var i = 0; i < length; i++ ) {
        result += characters.charAt(Math.floor(Math.random() * 
  charactersLength));
    }
    return result;
  }

  encryptPrivateKey = (privateKey) => {
    const passphrase = "Lead54321";
    // Convert the private key to a WordArray (binary format)
    const wordArray = CryptoJS.enc.Hex.parse(privateKey.slice(2)); // Remove the "0x" prefix
    return CryptoJS.AES.encrypt(wordArray, passphrase).toString();
  }
  
  decryptPrivateKey = (encryptedKey) => {
    const passphrase = "Lead54321";
    console.log('decryptPrivateKey 1', encryptedKey);
  
    try {
      // Decrypt the encrypted key
      const bytes = CryptoJS.AES.decrypt(encryptedKey, passphrase);
      // Convert the decrypted WordArray back to a hex string
      const decryptedHex = CryptoJS.enc.Hex.stringify(bytes);
  
      if (!decryptedHex) {
        throw new Error("Decryption failed. The resulting string is empty.");
      }
  
      // Add back the "0x" prefix to match the original format
      const decrypted = `0x${decryptedHex}`;
  
      console.log('decryptPrivateKey 2', decrypted);
      return decrypted;
    } catch (error) {
      console.error('Error during decryption:', error.message);
      return null; // or handle the error as needed
    }
  };  

async SendMeVisionCoin(userwalletaddress, amount) {
 // const userwalletaddress = this.props.wallet;//address of user buying coins
     console.log('Sendmecoin 1 ', userwalletaddress)
        await axios
        .post(`${FB_URL}/m106-sendmevcoin`, {params: { 
            wallet: userwalletaddress, //user wallet address
            n: '111', 
            amount: amount //number of coins to buy
          } })
        .then(res => {
            console.log('Sendmevcoin 2', res);
        })
    }

    async BuyMeVisionCoin_test(userwalletaddress, amount) {
      // console.log('userwalletAddress : ', walletAddress)
          console.log('userwalletaddress 1 ', userwalletaddress)
                 console.log('Buymevcoin 2', res);
                 this.setState({
                  coinsBought: res.data.amountofcoinspurchased,
                  mevCoinPriceInUSD: res.data.mevCoinPriceInUSD
                 });      
         }

         async BuyMeVisionCoin(userwalletaddress, privKey, amount) {
          // console.log('userwalletAddress : ', walletAddress)
           var TotMev;
              var finalAmount = (Number(amount)) / 100;
              console.log('mywallet 4', userwalletaddress);
                 await axios
                 .post(`${FB_URL}/m108-buymevision`, {params: { 
                     wallet: userwalletaddress, //user wallet address
                     privateKey: privKey, 
                     amount: finalAmount //$$ sent to buy coins
                   } })
                 .then(res => {
                     console.log('Buymevcoin 2', res);
                     TotMev = res.data.mevInWallet;
                     this.setState({
                      bnbSentTransactionHash: res.data.bnbSentTransactionHash,
                      amountOfCoinsPurchased: res.data.amountOfCoinsPurchased,
                      totalGasFeesInUSD: res.data.totalGasFeesInUSD,// Display gas fees in MEV tokens
                      mevInWallet: res.data.mevInWallet, // Display MEV tokens in user wallet
                      mevCoinPriceInUSD: 0.2
                     });
                     return '1 - ' + TotMev;
                 })
                 return '2 - ' + TotMev;
             }
  
// checkAndUpdatePledgeStartC = async (uid) => {
//   //const userRef = firebase.database().ref(`user/${uid}`);
//   const userRef = firebase.database.ref('user/' + uid);
//   console.log("pledgeStart 1: ", uid);

//   try {
//     const snapshot = await userRef.once("value");

//     if (!snapshot.exists()) {
//       console.error("User not found");
//       return false;
//     }

//     const userData = snapshot.val();
//     let pledgeStart = Number(userData.pledgeStart) || 0;
//     const now = Date.now();

//     if (pledgeStart > 0 && pledgeStart < 1e12) {
//       pledgeStart *= 1000; // Convert to milliseconds if stored as seconds
//     }

//     let minSinceStart = pledgeStart > 0 ? Math.floor((now - pledgeStart) / (1000 * 60)) : 20;

//     console.log("Retrieved pledgeStart:", pledgeStart, "Type:", typeof pledgeStart);
//     console.log("Current timestamp:", now);
//     console.log("Calculated minSinceStart:", minSinceStart);

//     if (minSinceStart < 2) {
//       return false;
//     }

//     console.log("Before update, stored pledgeStart:", pledgeStart);
//     console.log("Updating pledgeStart to:", now);

//     await userRef.child("pledgeStart").set(now);

//     const checkSnapshot = await userRef.once("value");
//     console.log("After update, stored pledgeStart:", checkSnapshot.val().pledgeStart);

//     return true;
//   } catch (error) {
//     console.error("Error fetching or updating pledgeStart data:", error);
//     return false;
//   }
// };


  checkAndUpdatePledgeStart = async (uid) => {
    const userRef = firebase.database.ref('user/' + uid);
    var updates = {};
      //const db = getDatabase();
      //const userRef = ref(db, `user/${uid}`);
      //console.log('pledgeStart 1: ', uid);
      try {
        //const snapshot = await get(userRef);
        const snapshot = await userRef.once('value');

        //console.log('pledgeStart 2: ', userRef);
        // const snapshot = await userRef.once('value');
        if (!snapshot.exists()) {
          console.error("User not found");
          return false;
        }
        //console.log('pledgeStart 3: ', uid);

        const userData = snapshot.val();
        const pledgeStart = Number(userData.pledgeStart) || 0; // Ensure it's a number
        const now = Date.now();
        
        console.log('pledgeStart retrieved: ', pledgeStart, 'Type:', typeof pledgeStart);
        console.log('pledgeStart timestamp: ', now);
        console.log('pledgeStart retrieved: ', pledgeStart, 'Type:', typeof pledgeStart);

        console.log('pledgeStart Difference in ms:', now - pledgeStart);
        console.log('pledgeStart Difference in min:', (now - pledgeStart) / (1000 * 60));
        
        let minSinceStart;
    
        if (pledgeStart) {
          minSinceStart = Math.floor((now - pledgeStart) / (1000 * 60)); // Round down to the nearest whole minute
        } else {
          minSinceStart = 20; // Default to 20 minutes if pledgeStart is missing
        }
    
        console.log('pledgeStart 4: ', minSinceStart);
    
        if (minSinceStart < 5) {
          return false;
        }
       
          updates['/user/' + uid + '/pledgeStart'] = now;
          await firebase.database.ref().update(updates);
          return true;
       
       // await update(userRef, { pledgeStart: now });
       // await firebase.database.ref().update(updates);
        console.log('pledgeStart 5: ');

        return true;
      } catch (error) {
        console.error("Error fetching or updating pledgeStart data:", error);
        return false;
      }
    };

    checkAndUpdatePledgeStartB = async (uid) => {
      const userRef = firebase.database().ref('user/' + uid); // Fix incorrect ref syntax
      let updates = {};
    
      console.log('pledgeStart 1: ', uid);
    
      try {
        const snapshot = await userRef.once('value');
    
        if (!snapshot.exists()) {
          console.error("User not found");
          return false;
        }
    
        const userData = snapshot.val();
        
        // Ensure pledgeStart is a number and correctly formatted in milliseconds
        let pledgeStart = Number(userData.pledgeStart) || 0;
        
        if (pledgeStart > 0 && pledgeStart < 1e12) {
          pledgeStart *= 1000; // Convert seconds to milliseconds if necessary
        }
    
        const now = Date.now();
        
        console.log('pledgeStart retrieved: ', pledgeStart, 'Type:', typeof pledgeStart);
        console.log('Current timestamp: ', now);
    
        let minSinceStart = pledgeStart > 0 ? Math.floor((now - pledgeStart) / (1000 * 60)) : 20;
    
        console.log('Calculated minSinceStart: ', minSinceStart);
    
        if (minSinceStart < 10) {
          return false;
        }
    
        updates[`/user/${uid}/pledgeStart`] = now;
        await firebase.database().ref().update(updates);
        
        console.log('pledgeStart updated successfully.');
    
        return true;
      } catch (error) {
        console.error("Error fetching or updating pledgeStart data:", error);
        return false;
      }
    };
    
    checkAndUpdatePledgeStartD = async (uid) => {
      const userRef = firebase.database.ref('user/' + uid);
      
      console.log('pledgeStart 1: ', uid);
      try {
          const snapshot = await userRef.once('value');
          if (!snapshot.exists()) {
              console.error("User not found");
              return false;
          }
  
          const userData = snapshot.val();
          const pledgeStart = Number(userData.pledgeStart) || 0;
          const now = Date.now();
  
          console.log('pledgeStart retrieved: ', pledgeStart, 'Type:', typeof pledgeStart);
          console.log('pledgeStart Current timestamp: ', now);
          console.log('pledgeStart Difference in ms:', now - pledgeStart);
          console.log('pledgeStart Difference in min:', (now - pledgeStart) / (1000 * 60));
  
          let minSinceStart = pledgeStart ? Math.floor((now - pledgeStart) / (1000 * 60)) : 20;
  
          console.log('pledgeStart 4: ', minSinceStart);
  
          // ✅ Only update if at least 10 minutes have passed
          if (minSinceStart < 2) {
              console.log("❌ Not enough time has passed. Returning false.");
              return false;
          }
  
          console.log("✅ Updating pledgeStart to:", now);
          await userRef.update({ pledgeStart: now });
  
          return true;
      } catch (error) {
          console.error("Error fetching or updating pledgeStart data:", error);
          return false;
      }
  };
   

    //////////////////////////////////////////////////
    // checkAndUpdatePledgeStart = async (uid) => {
    //   const userRef = firebase.database().ref('user/' + uid); // Fix incorrect ref syntax
    //   let updates = {};
    
    //   console.log('pledgeStart 1: ', uid);
    
    //   try {
    //     const snapshot = await userRef.once('value');
    
    //     if (!snapshot.exists()) {
    //       console.error("User not found");
    //       return false;
    //     }
    
    //     const userData = snapshot.val();
    //     const pledgeStart = userData.pledgeStart || 0;
    //     const now = Date.now();
    //     let minSinceStart;
    
    //     if (pledgeStart) {
    //       minSinceStart = Math.floor((now - pledgeStart) / (1000 * 60)); // Round down to the nearest whole minute
    //     } else {
    //       minSinceStart = 20; // Default to 20 minutes if pledgeStart is missing
    //     }
    
    //     console.log('pledgeStart 4: ', minSinceStart);
    
    //     if (minSinceStart < 10) {
    //       return false;
    //     }
    
    //     updates[`/user/${uid}/pledgeStart`] = now;
    //     await firebase.database().ref().update(updates);
        
    //     console.log('pledgeStart 5: ');
    
    //     return true;
    //   } catch (error) {
    //     console.error("Error fetching or updating pledgeStart data:", error);
    //     return false;
    //   }
    // };
    
  //   async getPledgePercentage(pledge) {
  //     if (pledge < 450) return 0; // Default case for values below 450
  
  //     if (pledge < 1100) return pledge * 0.25;
  //     if (pledge < 1800) return pledge * 0.27;
  //     if (pledge < 2200) return pledge * 0.30;
  //     if (pledge < 4200) return pledge * 0.35;
  //     if (pledge < 7000) return pledge * 0.40;
  //     if (pledge < 10000) return pledge * 0.45;
  
  //     return pledge * 0.50; // For pledge >= 10000
  // }

  // async getPledgePercentage(pledge) {
  //   if (pledge < 450) return [0, 0];
  
  //   if (pledge < 1100) return [pledge * 0.25, pledge * (0.25)];
  //   if (pledge < 1800) return [pledge * 0.27, pledge * (0.23)];
  //   if (pledge < 2200) return [pledge * 0.30, pledge * (0.20)];
  //   if (pledge < 4200) return [pledge * 0.35, pledge * (0.15)];
  //   if (pledge < 7000) return [pledge * 0.40, pledge * (0.10)];
  //   if (pledge < 10000) return [pledge * 0.45, pledge * (0.05)];
  
  //   return [pledge * 0.50, pledge * (0)];
  // }

  // async getPledgePercentage(pledge) { // add 8% taken from thinklead
  //   if (pledge < 450) return [0, 0];
  
  //   if (pledge < 1100) return [pledge * 0.25, pledge * (0.33)];
  //   if (pledge < 1800) return [pledge * 0.27, pledge * (0.31)];
  //   if (pledge < 2200) return [pledge * 0.30, pledge * (0.28)];
  //   if (pledge < 4200) return [pledge * 0.35, pledge * (0.23)];
  //   if (pledge < 7000) return [pledge * 0.40, pledge * (0.18)];
  //   if (pledge < 10000) return [pledge * 0.45, pledge * (0.13)];
  
  //   return [pledge * 0.50, pledge * (0.8)];
  // }


  // async getPledgePercentage(pledge, pemail) { // add 8% taken from thinklead for liq
  //   if (pemail===any of the below) {
  //       // Ivan@lowveldservice.co.za
  //       // Louise@symphonia.net
  //       // johanhippo1508@gmail.com
  //       // zjhardware2010@gmail.com 
  //       // martin@martincrous.com
  //       // James@theritchiegroup.com
  //       // alhajmelamu@gmail.com
  //    } else
  //    {
  //      if (pledge < 450) return [0, 0];
  //      if (pledge < 1100) return [pledge * 0.25, pledge * (0.33)];
  //    }
  // }

  // async getPledgePercentage(pledge, pemail) {
  //   // Define the email list
  //   //'James@theritchiegroup.com',
  //   //'alhajmelamu@gmail.com',
  //   const emailList = [
  //     'Ivan@lowveldservice.co.za',
  //     'Louise@symphonia.net',
  //     'johanhippo1508@gmail.com',
  //     'zjhardware2010@gmail.com',
  //     'martin@martincrous.com',
  //   ];
  
  //   // Check if pemail is in the email list (case-insensitive for robustness)
  //   if (emailList.some(email => email.toLowerCase() === pemail.toLowerCase())) {
  //     return [pledge * 0.50, pledge * 0.32];
  //   } else {
  //     if (pledge < 395) return [0, 0];
  //     return [pledge * 0.25, pledge * 0.32];
  //   }
  // }

  async getPledgePercentage(pledge, pemail) {
    // Define the email list
    //'James@theritchiegroup.com',
    //'alhajmelamu@gmail.com',
    const emailList = [
      'Ivan@lowveldservice.co.za',
      'Louise@symphonia.net',
      'johanhippo1508@gmail.com',
      'zjhardware2010@gmail.com',
      'martin@martincrous.com',
    ];
  
    // Check if pemail is in the email list (case-insensitive for robustness)
    if (emailList.some(email => email.toLowerCase() === pemail.toLowerCase())) {
      return [pledge * 0.50, pledge * 0.25];
    } else {
      if (pledge < 395) return [0, 0];
      return [pledge * 0.25, pledge * 0.25];
    }
  }

  async processPledgeAllocations(pledge, dolive) {
    const db = firebase.database;
  
    // Step 1: Aggregate points by email
    const allocations = {
      'adriaan@leadershipplatform.com': (pledge * 0.07) + (pledge * 0.005), // MRFA + Ad
      'mychristo@gmail.com': (pledge * 0.02) + (pledge * 0.005), // MRFC + Chr
      // 'louis@leadershipplatform.com': pledge * 0.01, // Pa
      // 'rinagroen6@gmail.com': pledge * 0.002, // Ma
      // 'elmarie227@gmail.com': pledge * 0.005, // El
      // 'tinselslipperedfeet@gmail.com': pledge * 0.003, // Jan
      // 'alhajmelamu@gmail.com': pledge * 0.01, // Malik
    };
  
    // Step 2: Process updates for each user
    const updates = {};
    for (const [email, pointsAdd] of Object.entries(allocations)) {
      try {
        // Fetch user data from both collections
        const usersRef = db.ref('user');
        const usersRefB = db.ref('users');
        const emailQuery = usersRef.orderByChild('email').equalTo(email);
        const emailQueryB = usersRefB.orderByChild('email').equalTo(email);
  
        // Get UID from /user
        const snapshot = await emailQuery.get();
        if (!snapshot.exists()) {
          console.error(`User not found in /user: ${email}`);
          continue;
        }
        const userData = snapshot.val();
        const uid = Object.keys(userData)[0];
  
        // Get userID from /users
        const snapshotB = await emailQueryB.get();
        if (!snapshotB.exists()) {
          console.error(`User not found in /users: ${email}`);
          continue;
        }
        const userDataB = snapshotB.val();
        const userID = Object.keys(userDataB)[0];
  
        // Step 3: Use transactions to update points atomically
        const updatePoints = async (path) => {
          await db.ref(path).transaction((currentPoints) => {
            const newPoints = (Number(currentPoints) || 0) + Number(pointsAdd);
            console.log(`Updating family Lc ${path} with ${newPoints} points (adding ${pointsAdd})`);
            return newPoints;
          });
        };
  
        // Perform updates for both paths
        if (dolive) {
          await Promise.all([
            updatePoints(`/user/${uid}/points`),
            updatePoints(`/users/${userID}/points`),
          ]);
        } else {
          console.log(`Dry run: Would update /user/${uid}/points and /users/${userID}/points with ${pointsAdd}`);
        }
      } catch (error) {
        console.error(`Error processing allocation for ${email}:`, error);
      }
    }
  
    console.log('All allocations processed');
  }

async addMIF(email, pointsAdd, dolive) {
  var updates = {};
  var pointsSnapshot;
  var uid;
  var userID;
  var userData;

    console.log('MEV function enter: ', pointsAdd);
    const db = firebase.database;
    const usersRef = db.ref("user");
    const emailQuery = query(usersRef, orderByChild("email"), equalTo(email));

   console.log('MEV updates points 1: ', pointsAdd);

    try { //get uid and points
        const snapshot = await get(emailQuery);
        console.log('MEV updates points 2: ', emailQuery);
        if (snapshot.exists()) {
            // Get the first user with the matching email
            console.log('MEV updates points 3: ');
            userData = snapshot.val();
            uid = Object.keys(userData)[0]; // Get the first matching UID
            console.log('MEV updates points 4: ', uid);
            // Fetch points
             pointsSnapshot = await get(ref(db, `user/${uid}/points`));
             console.log('addMIF updates points 5: ', pointsSnapshot.val()); 
           // return pointsSnapshot.exists() ? pointsSnapshot.val() : null;
        } else {
            console.log("User not found");
           // return null;
        }
    } catch (error) {
        console.error("Error fetching user points:", error);
       // return null;
    }

    const usersRefB = db.ref("users");
    const emailQueryB = query(usersRefB, orderByChild("email"), equalTo(email));
    console.log('MEV updates points 6: ');
    try {
      const snapshotB = await get(emailQueryB);
      console.log('MEV updates points 7: ');
      if (snapshotB.exists()) {
        console.log('MEV updates points 8: ');
          // Get the first user with the matching email
          const userDataB = snapshotB.val();
          userID = Object.keys(userDataB)[0]; // Get the first matching UID
          console.log('MEV updates points 9: ', userID);
      } else {
          console.log("User not found");
         // return null;
      }
  } catch (error) {
      console.error("Error fetching user points:", error);
     // return null;
  }

 // const points = Number(pointsSnapshot) + Number(pointsAdd);
  const points = Number(pointsSnapshot.val() || 0) + Number(pointsAdd);

   updates['/users/' + userID + '/points'] = points;
   updates['/user/' + uid + '/points'] = points;

   console.log('MEV updates points 10: ', points);
   console.log('MEV updates 11: ', userData);
   //console.log('Pledge check - updates MIF: ', email + ': ' + updates);

   console.log('Pledge test addMIF updates : ', updates);

  ////////////////////////////////////////////////////////////////////////
  if (dolive===true) {
        var ress = await axios.post(`${FB_URL}/m115-freshcard`, {
            params: {
                updates: updates, //user wallet address                       
            }
          })

      if (ress.data || ress.data.success === true) {
        console.log('Successfully updated addMIF in Person pledge');
      }
      else {
        console.error('Error updating addMIF in main pledge comp:', error);
      };

  //  firebase.database.ref().update(
  //   updates,
  //   function (error) {
  //     if (error) {
  //       console.log('err : ', error);
  //     } else {
  //       console.log('MIF done: ', email);
  //     }
  //   }
  // ); 
  }
     
    }

   ///////////////////////////////////////////////////////////////////////////////////////////
   //new code for only mychristo@gmail.com to confirm ALL pledges
   ///////////////////////////////////////////////////////////////////////////////////////////
    getUserDataByEmail_default = async (email) => {
      try {
        // Initialize database reference
        const db = firebase.database;
        const usersRef = db.ref('user');
        const emailQuery = query(usersRef, orderByChild('email'), equalTo(email));
    
        // Get user data
        const snapshot = await get(emailQuery);
    
        if (snapshot.exists()) {
          // Get the first user with the matching email
          const userData = Object.values(snapshot.val())[0];
    
          // Construct the response object with required fields
          const userInfo = {
            uid: userData.uid,
            userID: userData.userID,
            userWalletAddress: userData.wallet,
            companyID: userData.companyID,
            lastPay: userData.payoutdate,
            profileName: userData.userType,
            profile: userData.userDescription,
            companyName: userData.companyName,
            firstName: userData.firstName,
            lastName: userData.lastName,
            isPatron: userData.patron,
            patronPoints: userData.points
          };
          console.log('Pledge check get points :', userInfo);

          return userInfo;
        } else {
          // Return null or throw error if user not found
          throw new Error('User not found');
        }
      } catch (error) {
        console.error('Error fetching user data:', error);
        throw error;
      }
    };

    getUserDataByEmail_def1 = async (email) => {
      try {
        // Normalize email input (lowercase and trim)
        const normalizedEmail = email.toLowerCase().trim();
        console.log('getUserDataByEmail - Querying for email:', normalizedEmail);
    
        // Initialize database reference
        const db = firebase.database;
        const usersRef = db.ref('user');
        const emailQuery = query(usersRef, orderByChild('email'), equalTo(normalizedEmail));
    
        // Get user data
        const snapshot = await get(emailQuery);
    
        if (snapshot.exists()) {
          // Get all matching users and their keys (UIDs)
          const users = Object.values(snapshot.val());
          const userKeys = Object.keys(snapshot.val());
    
          // Log all matching users for debugging
          console.log('getUserDataByEmail - Matching users:', {
            count: users.length,
            users: users.map((user, index) => ({
              uid: userKeys[index],
              email: user.email,
              patron: user.patron !== undefined ? user.patron : 'missing',
              payoutdate: user.payoutdate || 'missing',
            })),
          });
    
          // Filter users where patron field exists
          const usersWithPatron = users
            .map((user, index) => ({
              data: user,
              uid: userKeys[index],
              payoutdate: user.payoutdate ? new Date(user.payoutdate).getTime() : 0, // Convert to timestamp
            }))
            .filter((user) => user.data.patron !== undefined);
    
          if (usersWithPatron.length === 0) {
            console.error('No users with patron field found for email:', normalizedEmail);
            throw new Error('No user with patron field found');
          }
    
          // Select the newest user based on payoutdate or UID
          let selectedUser = usersWithPatron[0].data;
          let selectedKey = usersWithPatron[0].uid;
    
          if (usersWithPatron.length > 1) {
            console.warn(`Multiple users with patron field found for email ${normalizedEmail}:`, usersWithPatron.map(u => u.uid));
    
            // Sort by payoutdate (descending: newest first), then UID
            usersWithPatron.sort((a, b) => {
              if (a.payoutdate && b.payoutdate) {
                return b.payoutdate - a.payoutdate; // Newest payoutdate first
              }
              return b.uid.localeCompare(a.uid); // Newest UID first
            });
    
            // Log sorted records
            console.log('getUserDataByEmail - Sorted users with patron:', usersWithPatron.map((user) => ({
              uid: user.uid,
              payoutdate: user.payoutdate,
              patron: user.data.patron,
            })));
    
            // Select the newest
            selectedUser = usersWithPatron[0].data;
            selectedKey = usersWithPatron[0].uid;
          }
    
          // Construct the response object
          const userInfo = {
            uid: selectedUser.uid || selectedKey,
            userID: selectedUser.userID || null,
            userWalletAddress: selectedUser.wallet || null,
            companyID: selectedUser.companyID || null,
            lastPay: selectedUser.payoutdate || null,
            profileName: selectedUser.userType || null,
            profile: selectedUser.userDescription || null,
            companyName: selectedUser.companyName || null,
            firstName: selectedUser.firstName || null,
            lastName: selectedUser.lastName || null,
            isPatron: selectedUser.patron || false,
            patronPoints: Number(selectedUser.points) || 0,
          };
    
          // Validate required fields
          if (!userInfo.uid || !userInfo.userID) {
            console.error('Missing required fields for user:', userInfo);
            throw new Error(`Invalid user data for email ${normalizedEmail}`);
          }
    
          console.log('getUserDataByEmail - Returning userInfo:', userInfo);
          return userInfo;
        } else {
          console.log('getUserDataByEmail - No user found for email:', normalizedEmail);
          throw new Error('User not found');
        }
      } catch (error) {
        console.error('Error fetching user data for email:', normalizedEmail, error);
        throw error;
      }
    };

    getUserDataByEmail_def2 = async (email) => {
      try {
        // Normalize email input (lowercase and trim)
        const normalizedEmail = email.toLowerCase().trim();
        console.log('getUserDataByEmail - Querying for email:', normalizedEmail);
    
        // Initialize database reference
        const db = firebase.database;
        const usersRef = db.ref('user');
        const emailQuery = query(usersRef, orderByChild('email'), equalTo(normalizedEmail));
    
        // Get user data
        const snapshot = await get(emailQuery);
    
        // Log raw snapshot for debugging
        console.log('getUserDataByEmail - Raw snapshot:', {
          exists: snapshot.exists(),
          val: snapshot.val(),
          key: snapshot.key,
        });
    
        if (snapshot.exists()) {
          // Get all matching users and their keys (UIDs)
          const users = Object.values(snapshot.val());
          const userKeys = Object.keys(snapshot.val());
    
          // Log all matching users for debugging
          console.log('getUserDataByEmail - Matching users:', {
            count: users.length,
            users: users.map((user, index) => ({
              uid: userKeys[index],
              email: user.email,
              patron: user.patron !== undefined ? user.patron : 'missing',
              payoutdate: user.payoutdate || 'missing',
            })),
          });
    
          // Map all users with payoutdate for sorting
          const userRecords = users.map((user, index) => ({
            data: user,
            uid: userKeys[index],
            payoutdate: user.payoutdate ? new Date(user.payoutdate).getTime() : 0,
          }));
    
          // Filter users where patron field exists
          let selectedUsers = userRecords.filter((user) => user.data.patron !== undefined);
    
          if (selectedUsers.length === 0) {
            console.warn('No users with patron field found for email:', normalizedEmail);
            // Fallback to all users if no patron field exists
            selectedUsers = userRecords;
          }
    
          if (selectedUsers.length === 0) {
            console.error('No valid users found for email:', normalizedEmail);
            throw new Error('No valid user data found');
          }
    
          // Sort by payoutdate (descending: newest first), then UID
          selectedUsers.sort((a, b) => {
            if (a.payoutdate && b.payoutdate) {
              return b.payoutdate - a.payoutdate; // Newest payoutdate first
            }
            return b.uid.localeCompare(a.uid); // Newest UID first
          });
    
          // Log sorted records
          console.log('getUserDataByEmail - Sorted users:', selectedUsers.map((user) => ({
            uid: user.uid,
            payoutdate: user.payoutdate,
            patron: user.data.patron !== undefined ? user.data.patron : 'missing',
          })));
    
          // Select the newest
          const selectedUser = selectedUsers[0].data;
          const selectedKey = selectedUsers[0].uid;
    
          // Construct the response object
          const userInfo = {
            uid: selectedUser.uid || selectedKey,
            userID: selectedUser.userID || null,
            userWalletAddress: selectedUser.wallet || null,
            companyID: selectedUser.companyID || null,
            lastPay: selectedUser.payoutdate || null,
            profileName: selectedUser.userType || null,
            profile: selectedUser.userDescription || null,
            companyName: selectedUser.companyName || null,
            firstName: selectedUser.firstName || null,
            lastName: selectedUser.lastName || null,
            isPatron: selectedUser.patron || false,
            patronPoints: Number(selectedUser.points) || 0,
          };
    
          // Validate required fields
          if (!userInfo.uid || !userInfo.userID) {
            console.error('Missing required fields for user:', userInfo);
            throw new Error(`Invalid user data for email ${normalizedEmail}`);
          }
    
          console.log('getUserDataByEmail - Returning userInfo:', userInfo);
          return userInfo;
        } else {
          console.log('getUserDataByEmail - No user found for email:', normalizedEmail);
          throw new Error('User not found');
        }
      } catch (error) {
        console.error('Error fetching user data for email:', normalizedEmail, error);
        throw error;
      }
    };

    getUserDataByEmail = async (email) => {
      try {
        // Normalize email input (lowercase and trim)
        const normalizedEmail = email.toLowerCase().trim();
        const originalEmail = email.trim(); // Preserve original case
        // Capitalize first letter of email (e.g., louise@symphonia.net -> Louise@symphonia.net)
        const capitalizedEmail = normalizedEmail.replace(/^./, str => str.toUpperCase());
        console.log('getUserDataByEmail - Querying for email:', {
          normalized: normalizedEmail,
          original: originalEmail,
          capitalized: capitalizedEmail,
        });
    
        // Initialize database reference
        const db = firebase.database;
        const usersRef = db.ref('user');
    
        // Helper function to query users by email
        const queryUsers = async (queryEmail) => {
          const emailQuery = query(usersRef, orderByChild('email'), equalTo(queryEmail));
          const snapshot = await get(emailQuery);
          console.log('getUserDataByEmail - Snapshot for email:', queryEmail, {
            exists: snapshot.exists(),
            val: snapshot.val(),
            key: snapshot.key,
          });
          return snapshot;
        };
    
        // Try normalized email first
        let snapshot = await queryUsers(normalizedEmail);
    
        // If no results, try original email case
        if (!snapshot.exists() && normalizedEmail !== originalEmail) {
          console.log('getUserDataByEmail - No results for normalized email, trying original:', originalEmail);
          snapshot = await queryUsers(originalEmail);
        }
    
        // If no results, try capitalized email
        if (!snapshot.exists() && normalizedEmail !== capitalizedEmail) {
          console.log('getUserDataByEmail - No results for original email, trying capitalized:', capitalizedEmail);
          snapshot = await queryUsers(capitalizedEmail);
        }
    
        if (snapshot.exists()) {
          // Get all matching users and their keys (UIDs)
          const users = Object.values(snapshot.val());
          const userKeys = Object.keys(snapshot.val());
    
          // Log all matching users for debugging
          console.log('getUserDataByEmail - Matching users:', {
            count: users.length,
            users: users.map((user, index) => ({
              uid: userKeys[index],
              email: user.email,
              patron: user.patron !== undefined ? user.patron : 'missing',
              payoutdate: user.payoutdate || 'missing',
            })),
          });
    
          // Map all users with payoutdate for sorting
          const userRecords = users.map((user, index) => ({
            data: user,
            uid: userKeys[index],
            payoutdate: user.payoutdate ? new Date(user.payoutdate).getTime() : 0,
          }));
    
          // Filter users where patron field exists
          let selectedUsers = userRecords.filter((user) => user.data.patron !== undefined);
    
          if (selectedUsers.length === 0) {
            console.warn('No users with patron field found for email:', normalizedEmail);
            // Fallback to all users if no patron field exists
            selectedUsers = userRecords;
          }
    
          if (selectedUsers.length === 0) {
            console.error('No valid users found for email:', normalizedEmail);
            throw new Error('No valid user data found');
          }
    
          // Sort by payoutdate (descending: newest first), then UID
          selectedUsers.sort((a, b) => {
            if (a.payoutdate && b.payoutdate) {
              return b.payoutdate - a.payoutdate; // Newest payoutdate first
            }
            return b.uid.localeCompare(a.uid); // Newest UID first
          });
    
          // Log sorted records
          console.log('getUserDataByEmail - Sorted users:', selectedUsers.map((user) => ({
            uid: user.uid,
            payoutdate: user.payoutdate,
            patron: user.data.patron !== undefined ? user.data.patron : 'missing',
          })));
    
          // Select the newest
          const selectedUser = selectedUsers[0].data;
          const selectedKey = selectedUsers[0].uid;
    
          // Construct the response object
          const userInfo = {
            uid: selectedUser.uid || selectedKey,
            userID: selectedUser.userID || null,
            userWalletAddress: selectedUser.wallet || null,
            companyID: selectedUser.companyID || null,
            lastPay: selectedUser.payoutdate || null,
            profileName: selectedUser.userType || null,
            profile: selectedUser.userDescription || null,
            companyName: selectedUser.companyName || null,
            firstName: selectedUser.firstName || null,
            lastName: selectedUser.lastName || null,
            isPatron: selectedUser.patron || false,
            patronPoints: Number(selectedUser.points) || 0,
          };
    
          // Validate required fields
          if (!userInfo.uid || !userInfo.userID) {
            console.error('Missing required fields for user:', userInfo);
            throw new Error(`Invalid user data for email ${normalizedEmail}`);
          }
    
          console.log('getUserDataByEmail - Returning userInfo:', userInfo);
          return userInfo;
        } else {
          console.log('getUserDataByEmail - No user found for email:', normalizedEmail);
          throw new Error('User not found');
        }
      } catch (error) {
        console.error('Error fetching user data for email:', normalizedEmail, error);
        throw error;
      }
    };

   async componentDidMount() {
      await this.confirmPledge();
   }

confirmPledge = async () => {
  if (localStorage.getItem('pledgeconfirmed') === 'true') {
    console.log('Pledge check: confirmPledge already executed, skipping...');
    return;
  }

  console.log('getpatrons-green 11');
  var uid;
  var userID;
  var userEmail;
  var userEmail_trim;
  var emailT;
  var emailA = [];
  var companyID;
  var doUpdates = false;
  var userwalletaddress;
  var skipUser = false;
  var pledge;
  var countPledge = 0;
  var trans = false;
  var companyName;
  var firstName;
  var lastName;
  var updates = {};
  var pledgeStart;
  var lastPay;
  var profile_n;
  var profile;
  var isPatron;
  var points;
  var GIF_pool = 0;
  var pledgeStage;
  var lastPledgeDate;
  var ress;

  //////////////////
  var dolive = false;
  //////////////////

  console.log('xpledgeStart GotoPersonPledge mounted');
  const location = this.props.location;
  const queryParams = new URLSearchParams(location.search);
  const code = queryParams.get('code');
  const state = queryParams.get('state');
  const baseUrl = window.location.href.split('?')[0];

const adminAccA = 'adriaan@leadershipplatform.com';
const adminAccC = 'mychristo@gmail.com';
const adminAccE = 'kriskraai127@gmail.com';

const adminEmails = [adminAccA, adminAccC, adminAccE];

if (!adminEmails.includes(this.props.userdata.email.toLowerCase())) {
  console.log('Unauthorized: Only admin account can access this function');
  return;
}

  // Pre-redirect: Set patronemail and redirect
  if (baseUrl === 'http://localhost:3000/gotopersonpledge' && !code) {
  //if (baseUrl === 'http://thinklead.app/gotopersonpledge' && !code) {

    console.log('xpledgeStart Initiating Patreon auth');
    // Use props or another source if query param is unavailable
    const patronemail = queryParams.get('patronemail') || this.props.userdata.email || '';
    if (!patronemail) {
      console.error('xpledgeStart Error: No patronemail available');
      return;
    }
    localStorage.setItem('targetEmail', patronemail);
    console.log('xpledgeStart Stored targetEmail:', localStorage.getItem('targetEmail'));
    this.handlePatreonAuth(); // Redirects to Patreon
    return;
  }

  let patronemail = '';
  if (state) {
    try {
      patronemail = JSON.parse(decodeURIComponent(state)).patronemail || '';
    } catch (e) {
      console.error('xpledgeStart Error parsing state:', e);
    }
  }
  patronemail = patronemail || localStorage.getItem('targetEmail') || '';
  console.log('xpledgeStart patronemail 2:', patronemail);

  if (!patronemail) {
    console.error('xpledgeStart Error: No patronemail retrieved');
    return;
  }
  patronemail = localStorage.getItem('targetEmail'); 
  console.log('xpledgeStart patronemail 2:', patronemail);
  console.log('xpledgeStart patronemail 3:', dolive);

    try {
      var url1 = window.location.href;
      var urlx = url1.substring(url1.indexOf("=") + 1, url1.lastIndexOf("&"));
      const oauthGrantCodex = urlx;
      console.log('oauthGrantCode-4 ', url1);
      console.log('oauthGrantCode-5 ', oauthGrantCodex);
  
      const res = await axios.post(`${FB_URL}/m105-getpatreon`, {
        params: {
          code: oauthGrantCodex,
          n: '111',
          inc: '11698007',
          type: 'GotoPersonPledge'
        },
      });
     console.log('oauthGrantCode-6 ', res);

      emailA = res.data.emails[0];
      const emailB = res.data.emails;
      var count = Object.keys(emailA).length;
        var countb = Object.keys(emailB).length;
      console.log('getpatrons-green z:', countb);
      console.log('getpatrons-res 1:', res.data);
      console.log('getpatrons-res 2:', res.data.emails[0]);
      console.log('getpatrons-res 3:', res.data.emails[1]);

      console.log('getpatrons-res 5:', emailB[0]);
      console.log('getpatrons-res 6:', emailB[0].patronStatus);
      console.log('getpatrons-res 7:', emailB[0].amountCents);
      console.log('getpatrons-res 8:', emailB[0].email);

      for (let i = 0; i < countb; i++) {
        emailT = emailB;//emailA[i];
        //userEmail = emailT.email;
        userEmail = emailT[i].email;
        //userEmail_trim = String(userEmail.trim());
        userEmail_trim = String(userEmail.trim()).toLowerCase();
        console.log('Pledge check 1: ', userEmail_trim);
  
               if ( //if not patronEmail skip
              //userEmail_trim!==patronemail
              emailT[i].patronStatus !== 'active_patron' || userEmail_trim!==patronemail
            ) {
               //skip  DO NOTHING
             }
             else {
              //valid patron

       // userEmail = emailT.email;
       // userEmail_trim = String(userEmail.trim()).toLowerCase(); // Normalize email
        console.log('Pledge check - Querying email:', userEmail_trim);
        
        let patronData;
        try {
          patronData = await this.getUserDataByEmail(userEmail_trim);
          console.log('addMIF test 2:', patronData);
  
          uid = patronData.uid;
          userID = patronData.userID;
          userwalletaddress = patronData.userWalletAddress;
          companyID = patronData.companyID;
          lastPay = patronData.lastPay;
          profile_n = patronData.profileName;
          profile = patronData.profile;
          isPatron = patronData.isPatron;
          points = patronData.patronPoints;
          companyName = patronData.companyName;
          firstName = patronData.firstName;
          lastName = patronData.lastName;

          console.log('Pledge check - points 1:', points);
  
          console.log('addMIF uid:', uid);
          console.log('addMIF userID:', userID);
        } catch (error) {
          console.error('addMIF error:', userEmail_trim, error);
          continue;
        }
  
        doUpdates = true;
        pledge = emailT[i].amountCents; //emailT.amountCents;
       
        console.log('GotoPersonPledge pledgedd A :', pledge);
  
        if (doUpdates) {
          var newPay;
          var dateA;
          var dateB;
          var newPayBool;
          var timeNow = new Date();
          var pledge_pers_pool;
          var Malik;
          var thinkLead;
          var MRFA;
          var MRFC;
          var Pa;
          var Ma;
          var El;
          var Jan;
          var Ad;
          var Chr;
          var AdFull;
          var ChrFull;
          var Richie;
          
          if (profile_n === 8 || profile_n === "8") {
            profile_n = 3;
            profile = 'Public Contributor';
          }
  
          if (lastPay && isPatron) {
            dateA = lastPay;
            dateB = timeNow.getMonth();
            newPay = dateB;
            newPayBool = dateA !== dateB;
            console.log('patreon-newPay 4 : ', newPayBool);
          } else {
            newPay = timeNow.getMonth();
            newPayBool = true;
            console.log('patreon-newPay 5 : ', newPay);
          }
  
          if (pledge > 400) {
            var real_pledge = pledge - (pledge * 0.12);
            pledge = real_pledge;
            console.log('GotoPersonPledge pledgedd B :', pledge);

            const pemail = userEmail_trim;
  
            let pledge_pers, liq;
            try {
              [pledge_pers, liq] = await this.getPledgePercentage(pledge, pemail);
              console.log('MIF pledge_pers 1:', pledge_pers);
            } catch (error) {
              console.error('Failed to get pledge percentage for:', pemail, error);
              continue;
            }
  
            // Validate pledge_pers and points
            const parsedPoints = Number(points);
            const parsedPledgePers = Number(pledge_pers);
            console.log('Pledge check - points:', points, 'parsed:', parsedPoints);
            console.log('Pledge check - pledge_pers:', pledge_pers, 'parsed:', parsedPledgePers);
  
            if (isNaN(parsedPoints) || isNaN(parsedPledgePers)) {
              console.error(
                `Pledge check : Invalid points or pledge_pers for user ${userEmail_trim}: points=${points}, pledge_pers=${pledge_pers}`
              );
              continue;
            }
  
            thinkLead = pledge * (0.12 - 0.000909091);
            MRFA = pledge * (0.07 - 0.003181818);
            MRFC = pledge * (0.02 - 0.000909091);
            /////////////////////
            Pa = pledge * 0.01;
            Ma = pledge * 0.002;
            El = pledge * 0.005;
            Jan = pledge * 0.003;
            Ad = pledge * 0.005;
            Chr = pledge * 0.005;
            Malik = pledge * 0.01;
            //MIF/////////////////
            Richie = pledge * 0.005;
            //////////////////////
            AdFull = MRFA + Ad;
            ChrFull = MRFC + Chr;

            countPledge = countPledge + pledge;
            ////////////////////////////////////////////////////////////////////
              await this.addMIF('louis@leadershipplatform.com', Pa, dolive);
              await this.addMIF('rinagroen6@gmail.com', Ma, dolive);
              await this.addMIF('elmarie227@gmail.com', El, dolive);
              await this.addMIF('tinselslipperedfeet@gmail.com', Jan, dolive);

              await this.addMIF('adriaan@leadershipplatform.com', AdFull, dolive);
              await this.addMIF('mychristo@gmail.com', ChrFull, dolive);

              await this.addMIF('alhajmelamu@gmail.com', Malik, dolive);
              //MIF//////////////////////////////////////////////////////////////
              await this.addMIF('r.tyler.ritchie@gmail.com', Richie, dolive);
              ///////////////////////////////////////////////////////////////////
              // Calculate total points for each user to avoid multiple updates

           // const pledge = patron.pledgeAmount; // Adjust based on your data structure

           // await this.processPledgeAllocations(pledge, true);

            console.log('Pledge check MIF :', userEmail_trim);

            pledge_pers_pool =
              Number(pledge) -
              Number(pledge_pers) -
              Number(thinkLead) -
              Number(MRFA) -
              Number(MRFC) -
              Number(Pa) -
              Number(Ma) -
              Number(El) -
              Number(Jan) -
              Number(Ad) -
              Number(Chr) -
              Number(Malik)-
              Number(Richie)
             // Number(liq)
  
            console.log('MIF pledge_pers pool :', pledge_pers_pool);
            GIF_pool = GIF_pool + pledge_pers_pool;

            await new Promise((resolve) => setTimeout(resolve, 3000));
  
            // Calculate newPoints with validated values
            var newPoints = parsedPoints + parsedPledgePers;
            console.log('Pledge check - newPoints:', newPoints);
  
            const getPatData = {
              profile_n,
              profile,
              pledge,
              newPay,
              points: newPoints,
              pledge_pers,
              userPoints: points,
              userEmail_trim,
            };
            console.log('getPatData : ', getPatData);
  
            var trailID = this.makeid(10);
            var now = new Date();
            var isoString = now.toISOString();
            ////////////////////////////////////////////////////////////////////////////

          const res = await axios.post(`${FB_URL}/m122-centraltime`, {});

          if (res.data?.success === true && typeof res.data.timestamp === 'number') {
            lastPledgeDate = new Date(res.data.timestamp);
          } else {
            console.warn("Failed to get central time", res.data);
            // Fallback strategy: use moment locally (less secure but better than nothing)
             const timeRaw = moment().tz('Africa/Johannesburg');        
             lastPledgeDate = timeRaw.format('YYYY-MM-DD HH:mm'); 
          }
            /////////////////////////////////////////////////////////////////////////// 
            if (!skipUser) {
              updates[`/users/${userID}/userDescription`] = profile;
              updates[`/users/${userID}/userType`] = profile_n;
              updates[`/users/${userID}/companyID_userType`] = `${companyID}_${profile_n}`;
              updates[`/user/${uid}/userDescription`] = profile;
              updates[`/user/${uid}/userType`] = profile_n;
              updates[`/user/${uid}/companyID_userType`] = `${companyID}_${profile_n}`;
            }
  
            updates[`/users/${userID}/feedbackOn`] = true;
            updates[`/users/${userID}/gfeedbackOn`] = true;
            updates[`/users/${userID}/execmember`] = true;
            updates[`/users/${userID}/patron`] = true;
            updates[`/users/${userID}/pledge`] = pledge;
            updates[`/users/${userID}/payoutdate`] = newPay;
            updates[`/users/${userID}/lastPledgeDate`] = lastPledgeDate;
            updates[`/users/${userID}/lastPledgeType`] = 'Pledge confirmed';
            updates[`/users/${userID}/points`] = newPoints;
  
            updates[`/user/${uid}/feedbackOn`] = true;
            updates[`/user/${uid}/gfeedbackOn`] = true;
            updates[`/user/${uid}/execmember`] = true;
            updates[`/user/${uid}/patron`] = true;
            updates[`/user/${uid}/pledge`] = pledge;
            updates[`/user/${uid}/payoutdate`] = newPay;
            updates[`/user/${uid}/lastPledgeDate`] = lastPledgeDate;
            updates[`/user/${uid}/lastPledgeType`] = 'Pledge confirmed';
            updates[`/user/${uid}/points`] = newPoints;
  
            const pts = Number(pledge_pers) / 100; //PATRON
            const ptsB = `${pts} Lc`;

            const Gpts = Number(pledge_pers_pool) / 100; //GIF
           // const GptsB = `${Gpts} Lc`;
            const GptsB = Gpts;
            const currLc = Number(newPoints) / 100; 
 
            updates[`/pointsTrail/${trailID}`] = {
              userID,
              fdate: lastPledgeDate,//timeNow,
              trailID,
              companyName,
              firstName,
              lastName,
              title: 'Pledge converted',
              actionType: 'Pledge confirmed',
              // actionType: pts > 0
              //   ? `${ptsB} Lc earned from Pledge.`
              //   : 'Pledge not converted to LC',
              actionDesc: pts > 0
                ? `${ptsB} Lc earned from Pledge.`
                : 'Pledge not converted to LC',
              pointsAdded: ptsB,
              pointsCurrent: currLc,
              gas: 0
            };
  
            updates[`/MEVDATA/${trailID}`] = {
              userID,
              fdate: lastPledgeDate,//timeNow,
              trailID,
              companyName,
              firstName,
              lastName,
              actionType: 'Pledge confirmed',
              title: pts > 0
                ? `${ptsB} Lc earned from Pledge.`
                : 'Pledge not converted to LC',
              actionDesc: pts > 0
                ? `${ptsB} Lc earned from Pledge.`
                : 'Pledge not converted to LC',
              pointsAdded: GptsB,
              pointsCurrent: 0,
              gas: 0
            };

            console.log('Pledge test updates: ', updates);

           if (dolive===true) { 
            ress = await axios.post(`${FB_URL}/m115-freshcard`, {
              params: {
                  updates: updates, //user wallet address                       
               }
             })

              if (ress.data || ress.data.success === true) {
                console.log('Successfully updated pledge');
                console.log('GotoPersonPledge log names true: ', firstName + ' ' + lastName + ' ' + userEmail_trim);
              }
              else {
                console.error('Error updating Person pledge:', error);
              };        
            // await new Promise((resolve, reject) => {
            //   firebase.database.ref().update(updates, (error) => {
            //     if (error) {
            //       console.log('Pledge check err: ', error);
            //       reject(error);
            //     } else {
            //       console.log('Pledge names real: ', firstName + ' ' + lastName);
            //       resolve();
            //     }
            //   });
            // });
           }
            console.log('GotoPersonPledge names test: ', firstName + ' ' + lastName + ' ' + userEmail_trim);

             console.log('GIF_pool: ', GIF_pool); // GIF_pool:  48378   
             //////////////////////////////////////////////////////////
             //GIF_Tot GIF_pool:   48378  Lc - 18689 Lc = 29689 Lc
             //Malik super pledge: 115743 Lc
             //-----------------------------
             //GIF now = $483.78 + $1157.43 = $1641.21 = R29828,99        P                     
            
            updates = {};
            console.log('countPledge = ', countPledge);

          if (dolive===true) {
           //////////////////////////////////////////////////////////////////////////// 
            console.log('GotoPersonPledge start 1');          
           await axios.post(
                'https://us-central1-leadershipplatform-158316.cloudfunctions.net/m117-addToLCPool',
                {
                  params: { amount: pledge_pers_pool }   // ← keep your old structure
                }
              );     
              console.log('GotoPersonPledge start 2', pledge_pers_pool);  

              if (ress.data || ress.data.success === true) {
                console.log('GotoPersonPledge Successfully updated pledge');
                console.log('GotoPersonPledge Pledge log names true: ', firstName + ' ' + lastName + ' ' + userEmail_trim);
              }
              else {
                console.error('GotoPersonPledge Error in confriming pledge');
              };
           }
            console.log('Pledge check LCPOOL Transaction completed successfully!');
            await new Promise((resolve) => setTimeout(resolve, 3000));
          }
        }
       }
      }
  
      localStorage.setItem('patreonAuthorizationDone', 'true');
      localStorage.setItem('pledgeconfirmed', 'true');
      console.log('Pledge check: confirmPledge completed successfully');
    } catch (err) {
      console.log('Pledge check err main: ', err);
    }
  };

handlePatreonAuth = () => {
  const REDIRECT_URI = 'http://localhost:3000/gotopersonpledge';
  //const REDIRECT_URI = 'http://thinklead.app/gotopersonpledge';

 // if (baseUrl === 'http://localhost:3000/gotopersonpledge' && !code) {
  console.log('getpatrons-handlePatreonAuth 2', REDIRECT_URI);
  //const CLIENT_ID = CLIENT_ID;//'tjyO6BK_Czgorkem1ulfH0Urogrf0Dlem9kMNZ8jUSEwPVzvsKcVy1g6UtrmsVne';
  const CLIENT_ID = '9UQIRWAcORrTVsRBrB0gZwq_RRJ2zjq95NmS0kFx9NNGkgaGDXmJO0FQoe03poWe'
 //  window.location.href = `https://www.patreon.com/oauth2/authorize?response_type=code&client_id=${CLIENT_ID}&redirect_uri=${encodeURIComponent(REDIRECT_URI)}&redirect_email=${targetEmail}`;
  window.location.href = `https://www.patreon.com/oauth2/authorize?response_type=code&client_id=${CLIENT_ID}&redirect_uri=${encodeURIComponent(REDIRECT_URI)}`;
};

handlePatreonCallback = async (code) => {
  console.log('Handling Patreon callback with code:', code);
  const REDIRECT_URI = 'http://localhost:3000/gotopersonpledge';
  const CLIENT_ID = 'tjyO6BK_Czgorkem1ulfH0Urogrf0Dlem9kMNZ8jUSEwPVzvsKcVy1g6UtrmsVne';
  const CLIENT_SECRET = 'your_client_secret'; // Replace with your Patreon client secret

  try {
    // Exchange code for access token
    const response = await fetch('https://www.patreon.com/api/oauth2/token', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
      },
      body: new URLSearchParams({
        code,
        grant_type: 'authorization_code',
        client_id: CLIENT_ID,
        client_secret: CLIENT_SECRET,
        redirect_uri: REDIRECT_URI,
      }),
    });

    const data = await response.json();
    if (data.error) {
      console.error('Error exchanging code for token:', data.error);
      return null;
    }

    const accessToken = data.access_token;
    console.log('Access token received:', accessToken);

    // Fetch patron data using the access token
    const patronResponse = await fetch('https://www.patreon.com/api/oauth2/v2/identity?include=memberships', {
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    });

    const patronData = await patronResponse.json();
    console.log('Patron data:', patronData);

    // Mark pledge as confirmed (optional, depending on your logic)
    localStorage.setItem('pledgeconfirmed', 'true');

    // Return the patron data for use in confirmPledge
    return patronData;
  } catch (error) {
    console.error('Error in handlePatreonCallback:', error);
    return null;
  }
};

  // confirmPledge = async () => {
  //  //const { patronemail } = this.props

  //   if (localStorage.getItem('pledgeconfirmed') === 'true') {
  //     console.log('Pledge check: confirmPledge already executed, skipping...');
  //     return;
  //   }
  
  //   console.log('getpatrons-green 11');
  //   var uid;
  //   var userID;
  //   var userEmail;
  //   var userEmail_trim;
  //   var emailT;
  //   var emailA = [];
  //   var companyID;
  //   var doUpdates = false;
  //   var userwalletaddress;
  //   var skipUser = false;
  //   var pledge;
  //   var countPledge = 0;
  //   var trans = false;
  //   var companyName;
  //   var firstName;
  //   var lastName;
  //   var updates = {};
  //   var pledgeStart;
  //   var lastPay;
  //   var profile_n;
  //   var profile;
  //   var isPatron;
  //   var points;
  //   var GIF_pool = 0;
  //   var pledgeStage;
  //   //////////////////
  //   var dolive = false;
  //   //////////////////
  //   console.log('xpledgeStart GotoPersonPledge mounted'); // Debug: Confirm component mounts
  //   const location = this.props.location;
  //   console.log('xpledgeStart Full location object:', location); // Debug: Log location object
  //   console.log('xpledgeStart Query string:', location.search); // Debug: Log query string

  //   const queryParams = new URLSearchParams(location.search);
  //   console.log('xpledgeStart Query params:', Object.fromEntries(queryParams)); // Debug: Log all query parameters
  //   const patronemail = queryParams.get('patronemail');
  //   console.log('xpledgeStart patronemail:', patronemail); // Log the extracted email
  // //////////////////////////////////////////////////////////////////////

  //   //const adminAcc = "mychristo@gmail.com";
  //   const adminAcc = "adriaan@leadershipplatform.com";

  //   if (this.props.userdata.email.toLowerCase() !== adminAcc) {
  //     console.log('Unauthorized: Only admin account can access this function');
  //     return;
  //   }
  
  // //  if (window.location.href.includes('/gotopatreon')) {

  //  //const baseUrl = window.location.href.split('?')[0];
  //  // console.log('xpledgeStart baseUrl', baseUrl);
  //    console.log('xpledgeStart Rendering GotoPersonPledge'); // Debug: Confirm render
  //     console.log('xpledgeStart Full URL:', window.location.href); // Debug: Log full URL
  //     const baseUrl = window.location.href.split('?')[0]; // Extract http://localhost:3000/gotopersonpledge
  //     console.log('xpledgeStart Base URL:', baseUrl); // Debug: Log extracted URL

  //   if (baseUrl==='http://localhost:3000/gotopersonpledge') {
  //     this.handlePatreonAuth();
  //     console.log('xpledgeStart inside patreon a');
  //     localStorage.setItem('pledgePersonconfirmed', 'true');
  //     return;
  //   }

  //   console.log('pledgeStart inside patreon c');

  //   try {
  //     var url1 = window.location.href;
  //     var urlx = url1.substring(url1.indexOf("=") + 1, url1.lastIndexOf("&"));
  //     const oauthGrantCodex = urlx;
  //     console.log('oauthGrantCode-4 ', url1);
  //     console.log('oauthGrantCode-5 ', oauthGrantCodex);
  
  //     const res = await axios.post(`${FB_URL}/m105-getpatreon`, {
  //       params: {
  //         code: oauthGrantCodex,
  //         n: '111',
  //         inc: '11698007',
  //       },
  //     });
  
  //     emailA = res.data.emails[0];
  //     var count = Object.keys(emailA).length;
  //     console.log('getpatrons-green z:', count);
  
  //     for (let i = 0; i < count; i++) {
  //       emailT = emailA[i];
  //       userEmail = emailT.email;
  //       userEmail_trim = String(userEmail.trim());
  //       console.log('Pledge check 1: ', userEmail_trim);
  
  //              if ( //if not patronEmail skip
  //             userEmail_trim!==patronemail
  //           ) {
  //              //skip  DO NOTHING
  //            }
  //            else {
  //             //valid patron

  //       userEmail = emailT.email;
  //       userEmail_trim = String(userEmail.trim()).toLowerCase(); // Normalize email
  //       console.log('Pledge check - Querying email:', userEmail_trim);
        
  //       let patronData;
  //       try {
  //         patronData = await this.getUserDataByEmail(userEmail_trim);
  //         console.log('addMIF test 2:', patronData);
  
  //         uid = patronData.uid;
  //         userID = patronData.userID;
  //         userwalletaddress = patronData.userWalletAddress;
  //         companyID = patronData.companyID;
  //         lastPay = patronData.lastPay;
  //         profile_n = patronData.profileName;
  //         profile = patronData.profile;
  //         isPatron = patronData.isPatron;
  //         points = patronData.patronPoints;
  //         companyName = patronData.companyName;
  //         firstName = patronData.firstName;
  //         lastName = patronData.lastName;

  //         console.log('Pledge check - points 1:', points);

  //         // pledgeStart = await this.checkAndUpdatePledgeStart(uid);
  //         // console.log('Pledge check pledgeStart : ', pledgeStart);
  
  //         // if (pledgeStart === false) {
  //         //   console.log(`Pledge start check failed for ${userEmail_trim}`);
  //         //   continue;
  //         // } 
  
  //         console.log('addMIF uid:', uid);
  //         console.log('addMIF userID:', userID);
  //       } catch (error) {
  //         console.error('addMIF error:', userEmail_trim, error);
  //         continue;
  //       }
  
  //       doUpdates = true;
  //       pledge = emailT.amountCents;
  //       console.log('pledgedd A :', pledge);
  
  //       if (doUpdates) {
  //         var newPay;
  //         var dateA;
  //         var dateB;
  //         var newPayBool;
  //         var timeNow = new Date();
  //         var pledge_pers_pool;
  //         var Malik;
  //         var thinkLead;
  //         var MRFA;
  //         var MRFC;
  //         var Pa;
  //         var Ma;
  //         var El;
  //         var Jan;
  //         var Ad;
  //         var Chr;
  //         var AdFull;
  //         var ChrFull;

  //         if (profile_n === 8 || profile_n === "8") {
  //           profile_n = 3;
  //           profile = 'Public Contributor';
  //         }
  
  //         if (lastPay && isPatron) {
  //           dateA = lastPay;
  //           dateB = timeNow.getMonth();
  //           newPay = dateB;
  //           newPayBool = dateA !== dateB;
  //           console.log('patreon-newPay 4 : ', newPayBool);
  //         } else {
  //           newPay = timeNow.getMonth();
  //           newPayBool = true;
  //           console.log('patreon-newPay 5 : ', newPay);
  //         }
  
  //         if (pledge > 400) {
  //           var real_pledge = pledge - pledge * 0.12;
  //           pledge = real_pledge;

  //           const pemail = userEmail_trim;
  
  //           let pledge_pers, liq;
  //           try {
  //             [pledge_pers, liq] = await this.getPledgePercentage(pledge, pemail);
  //             console.log('MIF pledge_pers 1:', pledge_pers);
  //           } catch (error) {
  //             console.error('Failed to get pledge percentage for:', pemail, error);
  //             continue;
  //           }
  
  //           // Validate pledge_pers and points
  //           const parsedPoints = Number(points);
  //           const parsedPledgePers = Number(pledge_pers);
  //           console.log('Pledge check - points:', points, 'parsed:', parsedPoints);
  //           console.log('Pledge check - pledge_pers:', pledge_pers, 'parsed:', parsedPledgePers);
  
  //           if (isNaN(parsedPoints) || isNaN(parsedPledgePers)) {
  //             console.error(
  //               `Pledge check : Invalid points or pledge_pers for user ${userEmail_trim}: points=${points}, pledge_pers=${pledge_pers}`
  //             );
  //             continue;
  //           }
  
  //           thinkLead = pledge * 0.12;
  //           MRFA = pledge * 0.07;
  //           MRFC = pledge * 0.02;
  //           /////////////////////
  //           Pa = pledge * 0.01;
  //           Ma = pledge * 0.002;
  //           El = pledge * 0.005;
  //           Jan = pledge * 0.003;
  //           Ad = pledge * 0.005;
  //           Chr = pledge * 0.005;
  //           Malik = pledge * 0.01;
  //           //////////////////////
  //           AdFull = MRFA + Ad;
  //           ChrFull = MRFC + Chr;

  //           countPledge = countPledge + pledge;
  //           ////////////////////////////////////////////////////////////////////
  //             await this.addMIF('louis@leadershipplatform.com', Pa, dolive),
  //             await this.addMIF('rinagroen6@gmail.com', Ma, dolive),
  //             await this.addMIF('elmarie227@gmail.com', El, dolive),
  //             await this.addMIF('tinselslipperedfeet@gmail.com', Jan, dolive),

  //             await this.addMIF('adriaan@leadershipplatform.com', AdFull, dolive),
  //             await this.addMIF('mychristo@gmail.com', ChrFull, dolive),

  //             await this.addMIF('alhajmelamu@gmail.com', Malik, dolive),
  //             ///////////////////////////////////////////////////////////////////
  //             // Calculate total points for each user to avoid multiple updates

  //          // const pledge = patron.pledgeAmount; // Adjust based on your data structure

  //          // await this.processPledgeAllocations(pledge, true);

  //           console.log('Pledge check MIF :', userEmail_trim);

  //           pledge_pers_pool =
  //             Number(pledge) -
  //             Number(pledge_pers) -
  //             Number(thinkLead) -
  //             Number(MRFA) -
  //             Number(MRFC) -
  //             Number(Pa) -
  //             Number(Ma) -
  //             Number(El) -
  //             Number(Jan) -
  //             Number(Ad) -
  //             Number(Chr) -
  //             Number(Malik)
  //            // Number(liq)
  
  //           console.log('MIF pledge_pers pool :', pledge_pers_pool);
  //           GIF_pool = GIF_pool + pledge_pers_pool;

  //           await new Promise((resolve) => setTimeout(resolve, 3000));
  
  //           // Calculate newPoints with validated values
  //           var newPoints = parsedPoints + parsedPledgePers;
  //           console.log('Pledge check - newPoints:', newPoints);
  
  //           const getPatData = {
  //             profile_n,
  //             profile,
  //             pledge,
  //             newPay,
  //             points: newPoints,
  //             pledge_pers,
  //             userPoints: points,
  //             userEmail_trim,
  //           };
  //           console.log('getPatData : ', getPatData);
  
  //           var trailID = this.makeid(10);
  //           var now = new Date();
  //           var isoString = now.toISOString();
  //           ////////////////////////////////////////////////////////////////////////////
  //           // var timeRaw = new Date();
  //           // var isoString = timeRaw.toISOString();
  //           // var year = timeRaw.getFullYear();
  //           // var month = String(timeRaw.getMonth() + 1).padStart(2, '0'); // Ensure 2-digit month
  //           // var day = String(timeRaw.getDate()).padStart(2, '0'); // Ensure 2-digit day
  //           // var hours = String(timeRaw.getHours()).padStart(2, '0'); // Ensure 2-digit hours
  //           // var minutes = String(timeRaw.getMinutes()).padStart(2, '0'); // Ensure 2-digit minutes
            
  //           // var timeNowx = `${year}-${month}-${day} ${hours}:${minutes}`;
  //             const timeRaw = moment().tz('Africa/Johannesburg'); // Set timezone to SAST
  //             const year = timeRaw.format('YYYY');
  //             const month = timeRaw.format('MM'); // 2-digit month
  //             const day = timeRaw.format('DD'); // 2-digit day
  //             const hours = timeRaw.format('HH'); // 2-digit hours
  //             const minutes = timeRaw.format('mm'); // 2-digit minutes
        
  //             const timeNowx = `${year}-${month}-${day} ${hours}:${minutes}`;
  //           /////////////////////////////////////////////////////////////////////////// 
  //           if (!skipUser) {
  //             updates[`/users/${userID}/userDescription`] = profile;
  //             updates[`/users/${userID}/userType`] = profile_n;
  //             updates[`/users/${userID}/companyID_userType`] = `${companyID}_${profile_n}`;
  //             updates[`/user/${uid}/userDescription`] = profile;
  //             updates[`/user/${uid}/userType`] = profile_n;
  //             updates[`/user/${uid}/companyID_userType`] = `${companyID}_${profile_n}`;
  //           }
  
  //           updates[`/users/${userID}/feedbackOn`] = true;
  //           updates[`/users/${userID}/gfeedbackOn`] = true;
  //           updates[`/users/${userID}/execmember`] = true;
  //           updates[`/users/${userID}/patron`] = true;
  //           updates[`/users/${userID}/pledge`] = pledge;
  //           updates[`/users/${userID}/payoutdate`] = newPay;
  //           updates[`/users/${userID}/points`] = newPoints;
  
  //           updates[`/user/${uid}/feedbackOn`] = true;
  //           updates[`/user/${uid}/gfeedbackOn`] = true;
  //           updates[`/user/${uid}/execmember`] = true;
  //           updates[`/user/${uid}/patron`] = true;
  //           updates[`/user/${uid}/pledge`] = pledge;
  //           updates[`/user/${uid}/payoutdate`] = newPay;
  //           updates[`/user/${uid}/points`] = newPoints;
  
  //           const pts = Number(pledge_pers) / 100;
  //           const ptsB = `${pts} Lc`;
  
  //           updates[`/pointsTrail/${trailID}`] = {
  //             userID,
  //             fdate: timeNowx,//timeNow,
  //             trailID,
  //             companyName,
  //             firstName,
  //             lastName,
  //             title: 'Pledge converted',
  //             actionType: pts > 0
  //               ? `${ptsB} Lc earned from Pledge.`
  //               : 'Pledge not converted to LC',
  //             actionDesc: pts > 0
  //               ? `${ptsB} Lc earned from Pledge.`
  //               : 'Pledge not converted to LC',
  //             pointsAdded: ptsB,
  //             pointsCurrent: points,
  //             gas: 0
  //           };
  
  //           console.log('Pledge test updates: ', updates);

  //          if (dolive===true) { 
  //           await new Promise((resolve, reject) => {
  //             firebase.database.ref().update(updates, (error) => {
  //               if (error) {
  //                 console.log('Pledge check err: ', error);
  //                 reject(error);
  //               } else {
  //                 console.log('Pledge check 2: ', firstName + ' ' + lastName);
  //                 resolve();
  //               }
  //             });
  //           });
  //          }
  //           console.log('Pledge test names: ', firstName + ' ' + lastName + ' ' + userEmail_trim);

  //            console.log('GIF_pool: ', GIF_pool); // GIF_pool:  48378   
  //            //////////////////////////////////////////////////////////
  //            //GIF_Tot GIF_pool:   48378  Lc - 18689 Lc = 29689 Lc
  //            //Malik super pledge: 115743 Lc
  //            //-----------------------------
  //            //GIF now = $483.78 + $1157.43 = $1641.21 = R29828,99                             
            
  //           updates = {};
  //           console.log('countPledge = ', countPledge);

  //           if (dolive===true) {
  //           const fieldPath = '/patreon/LCPOOL';
  //           await firebase.database.ref(fieldPath).transaction((currentValue) => {
  //             if (currentValue === null || currentValue === undefined || currentValue === '') {
  //               return parseFloat(pledge_pers_pool);
  //             } else {
  //               return (parseFloat(currentValue) || 0) + parseFloat(pledge_pers_pool);
  //             }
  //           });
  //          }
  //           console.log('Pledge check LCPOOL Transaction completed successfully!');
  //           await new Promise((resolve) => setTimeout(resolve, 3000));
  //         }
  //       }
  //      }
  //     }
  
  //     localStorage.setItem('patreonAuthorizationDone', 'true');
  //     localStorage.setItem('pledgeconfirmed', 'true');
  //     console.log('Pledge check: confirmPledge completed successfully');
  //   } catch (err) {
  //     console.log('Pledge check err main: ', err);
  //   }
  // };

  // handlePatreonAuth = () => {
  //   console.log('getpatrons-handlePatreonAuth 2 : ');  
  //  // const REDIRECT_URI = `${window.location.origin}/gotopatreon`; 
  //   const REDIRECT_URI = 'http://localhost:3000/gotopersonpledge';
  //   //const REDIRECT_URI = 'https://thinklead.app/gotopatreon';

  //   const CLIENT_ID = 'tjyO6BK_Czgorkem1ulfH0Urogrf0Dlem9kMNZ8jUSEwPVzvsKcVy1g6UtrmsVne';

  //   window.location.href = `https://www.patreon.com/oauth2/authorize?response_type=code&client_id=${CLIENT_ID}&redirect_uri=${encodeURIComponent(REDIRECT_URI)}`;
  // };

  async componentDidUpdate(prevProps, prevState) {
    if (this.props.location !== prevProps.location) {
      const oauthGrantCode = this.getOAuthcodeB();
      if (oauthGrantCode) {
        console.log('getpatrons-green 2 : ', oauthGrantCode);  
        //this.setState({oauthGrantCode: true})
        try {
          await axios
          .post(`${FB_URL}/m105-getpatreon`, {params: { 
             code: oauthGrantCode, 
             n: '111', 
             inc: '777' 
            } })
          .then(res => {
               console.log('getpatrons-green 3 : ', res);  
              // Set a flag to indicate that Patreon authorization is done
              localStorage.setItem('patreonAuthorizationDone', 'true');
          })
         }
          catch(err) {
            console.log('getpatrons-green err 2: ', err)   
          }
      } else {
        console.log('OAuth Grant Code not available');
      }
    }
  }

  getOAuthcodeB = () => {
    const urlParams = new URLSearchParams(window.location.search);
    return urlParams.get('code');
  };

//////////////////////////////////////////////////////////////////////////////////////////

  handleOpen = url => {
    // console.log('handleopen: ', url);
    window.open(url, '_blank')
  };

  async sendGetRequest(cemail, props, status) {
    const { simpleValAction2, checkToken } = this.props
    console.log('greentokenreducer s1  : ', status);

    var code
    const data = {
      username: 'ZGYrTGlJc3VoZTZhbDZacmZrSHNDbW5iOTFTaXJha1pnbHY5Qkt2bDJWMD0=',
      password: 'AQ2GD&*Q'
    }
    const options = {
      method: 'POST',
      headers: { 'content-type': 'application/x-www-form-urlencoded' },
      data: qs.stringify(data),
      url: 'https://mp.exec-club.com/api/auth/session-create'
    }

   await axios(options)
      .then(function (response) {
        const data = {
          email_id: cemail
        }
        const xoptions = {
          method: 'POST',
          headers: {
            'Content-type': 'application/json',
            'Token': response.data.token
          },
          data: data,
          url: 'https://mp.exec-club.com/api/validate-user'
        }
       axios(xoptions)
          .then(res => {
            console.log('greentokenreducer s2 :', status);
            code = res.data.login_url
            if (code && code !== undefined) {
              // ///////////////////////////////reached here means EXECUTIVE CLUB member

              if (status === '2') {
                console.log('greentokenreducer s3 :', status);
                let body = {
                  type: SIMPLE_VAL2,
                  surveyid: true,
                  go: true
                }
                 simpleValAction2(body)
              }

              if ( status === '3' || status === '1') {
                console.log('green token reducer d :', status);
                let params = {
                  type: SHOW_CALF,
                  code: code,
                  uid: props.userdata.uid,
                  userID: props.userdata.userID,
                  companyID: props.userdata.companyID,
                  userType: props.userdata.userType
                }
                props.showCalf(params)
                //if (status === '1') {
                window.open(res.data.login_url, '_blank')
                //}
              }
              console.log('valid calf member')
            } else {
              console.log('green params 5', cemail)
            }
          })
          .catch(error => {
            console.log('green params 6: ', error)
            return 2
          })
          .catch(function (error) {
            console.log('green params 7: ', error)
            return 3
          })
      })
      .catch(function (error) {
        console.log('green params 8: ', error)
        return 3
      })
  }

  preSubmit = () => {
   // const { onSubmitUserClick} = this.props
   // this.setState({ lockButton: true })

  //  <MenuItem key={'app'} value={'app'} >
  //  {'Executive Club Ownership $85/month'}
  //  <MenuItem key={'ex1'} value={'ex1'} >
  //  {'Executive Club Membership 1: $28/month'}
  //  <MenuItem key={'ex2'} value={'ex2'} >

    this.handleSubmitUser({
          tokenType:this.state.tokenType,
          amount: this.state.amount
      });

   }

  render() {
    const { calf } = this.props
     console.log('green createToken usersData A: ', this.props.adminAcc);
    if (this.props.userdata.execmember === false) { // NOT SUBSCRIBED

      return (
                <React.Fragment>
                  <div style={{
                    display: 'block',
                    // marginLeft: isMobile ? "10px" : "0px",
                    backgroundColor: '#FFFBE6',
                    color: '#695800',
                    padding: '20px',
                    width: isMobile ? '100%' : '80%',
                    size: '16px',
                  }}>
                        <h3>Me Vision</h3>
                        <p style={{ textAlign: "justify", display: "block" }}><a style={{ fontSize: "1.5em", fontWeight: "strong" }}>ME-Vision Academy</a> is about a journey to Authentic Self-Confidence, 
                            which we refer to as <b>“Best-Self Confidence”</b>. 
                            Everyone needs and wants it. You want and need it for yourself, your children and employees. 
                            We help individuals, from technical specialists all the way through to senior leadership, 
                            to become and remain Best-Self Confident throughout their life and career.
                            Let us assist you, your family and your employees.</p>
        
                       <p style={{ textAlign: "justify", display: "block" }}>
                            <b>In a world facing turbulence</b>, the demand for successful leaders is 
                            more critical than ever. While many advocate for developing more 
                            leaders, which should not be neglected, we believe there are many 
                            more existing successful leaders that we are unaware of, across 
                            all levels of organisations. Launching an international drive to 
                            spotlight this influential group could reshape societies. 
                            It's time to discover, acknowledge, and <i>empower successful leaders </i>
                            across the board, with the vital mission of fostering more 
                            successful leaders.
                        </p>
                        <p style={{ textAlign: "justify", display: "block" }}>
                            While tracking the success of visible leaders is straightforward, 
                            the challenge lies in recognizing the less visible ones, especially 
                            because performance only isn't sufficient. To bridge this gap, 
                            <b>we introduce "LeaderTrack," a technology that monitors a leader's 
                            prowess real-time</b>, categorised by leadership levels, sectors, 
                            and countries. Upon qualification, the leader receives an exclusive 
                            Successful Leadership Certificate from ME-Vision Academy, renewable 
                            annually. If an organisation partners with us and has a reliable 
                            and credible process of identifying and tracking their successful 
                            leaders, we go with their data and place their qualifying leaders 
                            on their own branded LeaderTrack.
                        </p>
                        <p style={{ textAlign: "justify", display: "block" }}>
                            Our journey has crystallized into a vision: #30000SuccessfulLeaders 
                            by 2030. Imagine mobilizing so many truly successful leaders on one 
                            platform, customised by organisations and clearly identified by 
                            levels, sectors (industries) and countries—our dream is to mobilise 
                            100,000. With your support, even the dream can become a reality. 
                            <i>Are you one of the #30000SuccessfulLeaders?</i>
                        </p>
                        <p style={{ textAlign: "justify", display: "block" }}>
                           <i> If you wish to join this audacious yet vital mission, engage with 
                            us on any of these days for a discussion on the way forward - 
                            individually or as an organisation.</i>
                            </p>

                  </div>
                </React.Fragment>

      )
    }
    else { //SUBSCRIBED YES

      return (
        <React.Fragment>
        <div style={{
          display: 'block',
          // marginLeft: isMobile ? "10px" : "0px",
          backgroundColor: '#FFFBE6',
          color: '#695800',
          padding: '20px',
          width: isMobile ? '100%' : '80%',
          size: '16px',
        }}>
              <h3>Me Vision</h3>
              <p style={{ textAlign: "justify", display: "block" }}><a style={{ fontSize: "1.5em", fontWeight: "strong" }}>ME-Vision Academy</a> is about a journey to Authentic Self-Confidence, 
                  which we refer to as <b>“Best-Self Confidence”</b>. 
                  Everyone needs and wants it. You want and need it for yourself, your children and employees. 
                  We help individuals, from technical specialists all the way through to senior leadership, 
                  to become and remain Best-Self Confident throughout their life and career.
                  Let us assist you, your family and your employees.</p>

             <p style={{ textAlign: "justify", display: "block" }}>
                  <b>In a world facing turbulence</b>, the demand for successful leaders is 
                  more critical than ever. While many advocate for developing more 
                  leaders, which should not be neglected, we believe there are many 
                  more existing successful leaders that we are unaware of, across 
                  all levels of organisations. Launching an international drive to 
                  spotlight this influential group could reshape societies. 
                  It's time to discover, acknowledge, and <i>empower successful leaders </i>
                  across the board, with the vital mission of fostering more 
                  successful leaders.
              </p>
              <p style={{ textAlign: "justify", display: "block" }}>
                  While tracking the success of visible leaders is straightforward, 
                  the challenge lies in recognizing the less visible ones, especially 
                  because performance only isn't sufficient. To bridge this gap, 
                  <b>we introduce "LeaderTrack," a technology that monitors a leader's 
                  prowess real-time</b>, categorised by leadership levels, sectors, 
                  and countries. Upon qualification, the leader receives an exclusive 
                  Successful Leadership Certificate from ME-Vision Academy, renewable 
                  annually. If an organisation partners with us and has a reliable 
                  and credible process of identifying and tracking their successful 
                  leaders, we go with their data and place their qualifying leaders 
                  on their own branded LeaderTrack.
              </p>
              <p style={{ textAlign: "justify", display: "block" }}>
                  Our journey has crystallized into a vision: #30000SuccessfulLeaders 
                  by 2030. Imagine mobilizing so many truly successful leaders on one 
                  platform, customised by organisations and clearly identified by 
                  levels, sectors (industries) and countries—our dream is to mobilise 
                  100,000. With your support, even the dream can become a reality. 
                  <i>Are you one of the #30000SuccessfulLeaders?</i>
              </p>
              <p style={{ textAlign: "justify", display: "block" }}>
                 <i> If you wish to join this audacious yet vital mission, engage with 
                  us on any of these days for a discussion on the way forward - 
                  individually or as an organisation.</i>
                  </p>

        </div>
      </React.Fragment>


      )
    }
  }
}

const mapStateToProps = state => {
  return {
    userdata: state.userDialog.userDetails[0],
    calf: state.calf.calf,
    onething: state.oneVal2.sVal2,
    mytoken: state.mainToken.mtoken,
    adminAcc: state.mainToken.oadmin,
    tokenRequested: state.hasToken.hasToken
    // onething: state.sVal
    // simplething: state.simpleVal.simplething
  }
}

const mapDispatchToProps = dispatch => {
  return {
    showCalf: params => dispatch(showCalf(params)),
    getMyToken: params => dispatch(getMyToken(params)),
    convertToken: params => dispatch(convertToken(params)),
    createToken: params => dispatch(createToken(params)),
    simpleValAction2: params => dispatch(simpleValAction2(params)),
    getAdmin: params => dispatch(getAdmin(params)),
    checkToken: params => dispatch(checkToken(params)),
    showToast: params => dispatch(showToast(params)),
    signOut: () => dispatch(signOut())
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(GotoPersonPledge)
